import React from 'react';
import { useHistory } from 'react-router-dom';

import { Container, Button, Col, Row } from 'reactstrap';

export const Continue = ({}: any) => {
    const history = useHistory();

    return (
        <Container>
            <Row className='justify-content-center py-5'>
                <Col md='6'>
                    <div className='text-center'>
                        <h3>
                            Congrats! You've been approved for fundraising.
                            Let's finish creating your campaign!
                        </h3>
                        <p>
                            Confirm your fundraising goal, tell your story, and
                            add a photo or video to grab attention.
                        </p>
                    </div>
                </Col>
            </Row>

            <div className='text-center mb-5'>
                <Button
                    color='primary'
                    onClick={() => history.push('/start-campaign/goal')}
                >
                    Create Your Campaign Page
                </Button>
                <Button
                    color='outline-dark'
                    onClick={() => history.push('/dashboard')}
                >
                    Go to Dashboard
                </Button>
            </div>
        </Container>
    );
};
